import axios, { AxiosRequestConfig } from "axios";
const http = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}auth/`,
});

http.interceptors.request.use(async (config: any) => {
  const { useAuthStore } = await require("@/stores/auth");
  const auth = useAuthStore();
  const token = auth.token;
  if (token) {
    (config.headers as any).Authorization = `Bearer ${token}`;
  }
  return config;
});
http.interceptors.response.use(
  (l) => l,
 async (error) => {
    if (error.response && error.response.status === 401 && error.response.data?.erro === 'Token unvalid') {
      const { useAuthStore } = await require("@/stores/auth");
      const auth = useAuthStore();
      auth.logout();
    }
    return Promise.reject(error);
  }
);

class AxiosCall {
  async axiosCall(config: AxiosRequestConfig) {
    const { data } = await http.request(config);
    return data;
  }
}

export { http, AxiosCall };
